const Packery = require('packery');
export default function () {
    const packeryInsts = [];
    const doms = document.querySelectorAll('[data-packery]');
    if (doms.length) {
        for (const dom of doms) {
            const pckry = new Packery(dom, {
                itemSelector: '[data-brick]',
                gutter: 0
            });
            packeryInsts.push(pckry)
        }

        window.addEventListener('load', () => {
            for (const inst of packeryInsts) {
                inst.layout();
            }
        });
    }
}

